import {
  // getReq,
  postReq,
  // deleteSendReq,
  // putReq,
  getCPHeaderMap,
  getHeaderCodeMap,
  // exportExcelReq,
  END_POINTS
} from '@/api'
import * as Utils from '@/utils'

// const baseUrl = process.env.BASE_URL

const state = {
  emptySearchInfo: {
    searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    searchFeeId: '',
    searchPaymentId: '',
    searchDocMth: '',
    searchDocIndex: 0,
    searchDocMonthIndex: '',
    searchDocType: '',
    searchColType: '',
    searchEntityId: '',
    // searchChecked: null,
    searchCheckedStatus: null
  },
  searchInfo: {
    // entityId: '',
    // projId: '',
    // compId: '',
    searchType: 'MONTH', // ALL, MONTH, DT_SCOPE
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    // startDt: null,
    // endDt: null
    searchFeeId: '',
    searchPaymentId: '',
    searchDocMth: '',
    searchDocIndex: 0,
    searchDocMonthIndex: '',
    searchDocType: '',
    searchColType: '',
    searchEntityId: '',
    // searchChecked: null,
    searchCheckedStatus: null
  },
  searchedForm: {
    // entityId: '',
    // projId: '',
    // compId: '',
    searchType: 'MONTH',
    searchMonth: Utils.getMonthFirstDay(new Date()), // 2019-10-01
    searchMonthType: 'CURRENT', // CURRENT, TOTAL
    // searchDtScope: [Utils.getMonthFirstDay(new Date()), Utils.getMonthLastDay(new Date())],
    searchStartDt: Utils.getMonthFirstDay(new Date()),
    searchEndDt: Utils.getMonthLastDay(new Date()),
    // startDt: new Date(0),
    // endDt: new Date(0)
    searchFeeId: '',
    searchPaymentId: '',
    searchDocMth: '',
    searchDocIndex: 0,
    searchDocMonthIndex: '',
    searchDocType: '',
    searchColType: '',
    searchEntityId: '',
    // searchChecked: null,
    searchCheckedStatus: null
  },
  transList: [],
  // transInfo: {
  //   transId: '',
  //   colType: '',
  //   compId: '',
  //   projId: '',
  //   entityId: '',
  //   // ctrAcctId: '',
  //   transDt: '',
  //   transSummary: '',
  //   contractAmt: 0,
  //   feeId: '',
  //   reimbOutputSettlAmt: 0,
  //   reimbOfficialSettlAmt: 0,
  //   payPlanAmt: 0,
  //   payDebtAmt: 0,
  //   payAmt: 0,
  //   paymentId: '',
  //   invAmt: 0,
  //   docMth: '',
  //   docIndex: 0,
  //   allowDuplicate: false,
  //   transRemarks: '',
  //   lockBy: '',
  //   lockOn: new Date(0),
  //   crtBy: '',
  //   crtOn: new Date(0),
  //   updBy: '',
  //   updOn: new Date(0),
  //   //
  //   indUsed: ''
  // },
  editIndex: -1,
  // justUpdatedIndex: -1,
  editAction: '',
  // editDocTransId: '',
  editDocMth: '',
  editDocIndex: 0,
  // editAllowDuplicate: false,
  END_STATE: null
}

const getters = {

}

const actions = {
  async findAccountantTransList({
    commit,
    state,
    rootState
  }, { projId, compId, codeParam }) {
    // debugger
    let searchedForm = state.searchedForm || state.emptySearchInfo
    // debugger
    let data = {
      // transId: transId,
      // entityId: entityId,
      projId: projId,
      compId: compId,
      entityId: searchedForm.searchEntityId || '',
      searchType: searchedForm.searchType,
      searchMonth: new Date(Utils.getMonthFirstDay(searchedForm.searchMonth)).getTime(),
      searchMonthType: searchedForm.searchMonthType,
      startDt: new Date(searchedForm.searchStartDt).getTime(),
      endDt: new Date(searchedForm.searchEndDt).getTime(),
      searchFeeId: searchedForm.searchFeeId || '',
      searchPaymentId: searchedForm.searchPaymentId,
      searchDocMth: searchedForm.searchDocMth,
      searchDocIndex: searchedForm.searchDocIndex || 0,
      searchDocMonthIndex: searchedForm.searchDocMonthIndex || '',
      searchDocType: searchedForm.searchDocType || '',
      searchColType: searchedForm.searchColType || '',
      // searchChecked: searchedForm.searchChecked || '',
      searchCheckedStatus: searchedForm.searchCheckedStatus || ''
    }

    const response = await postReq(END_POINTS.FIND_ACCOUNTANT_TRANS_LIST, {
      data,
      headerMap: await getCPHeaderMap(compId, projId),
      headerCodeMap: await getHeaderCodeMap(codeParam)
    })
    return response
  },
  END_ACTIONS() {}
}

const mutations = {
  async updateSearchedForm(state) {
    state.searchedForm = {...state.searchInfo}
  },
  async updateSearchInfo(state, searchInfo) {
    state.searchInfo = {...searchInfo}
  },
  async resetSearchInfo(state) {
    state.searchInfo = {...state.emptySearchInfo}
  },
  // updateSearchType(state, value) {
  //   state.searchInfo.searchType = value
  // },
  // updateSearchMonth(state, value) {
  //   state.searchInfo.searchMonth = value
  // },
  // updateSearchMonthType(state, value) {
  //   state.searchInfo.searchMonthType = value
  // },
  // updateSearchDtScope(state, value) {
  //   state.searchInfo.searchDtScope = value
  // },
  // updateSearchFeeId(state, value) {
  //   state.searchInfo.searchFeeId = value
  // },
  // updateSearchPaymentId(state, value) {
  //   state.searchInfo.searchPaymentId = value
  // },
  // updateSearchDocMth(state, value) {
  //   state.searchInfo.searchDocMth = value
  // },
  // updateSearchDocIndex(state, value) {
  //   state.searchInfo.searchDocIndex = value
  // },
  // updateSearchDocMonthIndex(state, value) {
  //   state.searchInfo.searchDocMonthIndex = value
  // },
  // updateSearchDocType(state, value) {
  //   state.searchInfo.searchDocType = value
  // },
  // updateSearchColType(state, value) {
  //   state.searchInfo.searchColType = value
  // },
  // updateSearchEntityId(state, value) {
  //   state.searchInfo.searchEntityId = value
  // },
  // updateSearchChecked(state, value) {
  //   state.searchInfo.searchChecked = value
  // },
  //
  // updateTransId(state, value) {
  //   state.transInfo.transId = value
  // },
  // updateColType(state, value) {
  //   state.transInfo.colType = value
  // },
  // updateCompId(state, value) {
  //   state.transInfo.compId = value
  // },
  // updateProjId(state, value) {
  //   state.transInfo.projId = value
  // },
  // updateEntityId(state, value) {
  //   state.transInfo.entityId = value
  // },
  // // updateCtrAcctId(state, value) {
  // //   state.transInfo.ctrAcctId = value
  // // },
  // updateTransDt(state, value) {
  //   state.transInfo.transDt = value
  // },
  // updateTransSummary(state, value) {
  //   state.transInfo.transSummary = value
  // },
  // updateContractAmt(state, value) {
  //   state.transInfo.contractAmt = value
  // },
  // updateFeeId(state, value) {
  //   state.transInfo.feeId = value
  // },
  // updateReimbOutputSettlAmt(state, value) {
  //   state.transInfo.reimbOutputSettlAmt = value
  // },
  // updateReimbOfficialSettlAmt(state, value) {
  //   state.transInfo.reimbOfficialSettlAmt = value
  // },
  // updatePayPlanAmt(state, value) {
  //   state.transInfo.payPlanAmt = value
  // },
  // updatePayDebtAmt(state, value) {
  //   state.transInfo.payDebtAmt = value
  // },
  // updatePayAmt(state, value) {
  //   state.transInfo.payAmt = value
  // },
  // updatePaymentId(state, value) {
  //   state.transInfo.paymentId = value
  // },
  // updateInvAmt(state, value) {
  //   state.transInfo.invAmt = value
  // },
  // updateDocMth(state, value) {
  //   state.transInfo.docMth = value
  // },
  // updateDocIndex(state, value) {
  //   state.transInfo.docIndex = value
  // },
  // updateAllowDuplicate(state, value) {
  //   state.transInfo.allowDuplicate = value
  // },
  // updateTransRemarks(state, value) {
  //   state.transInfo.transRemarks = value
  // },
  // updateLockBy(state, value) {
  //   state.transInfo.lockBy = value
  // },
  // updateLockOn(state, value) {
  //   state.transInfo.lockOn = value
  // },
  // updateIndDel(state, value) {
  //   state.transInfo.indDel = value
  // },
  // updateCrtBy(state, value) {
  //   state.transInfo.crtBy = value
  // },
  // updateCrtOn(state, value) {
  //   state.transInfo.crtOn = value
  // },
  // updateUpdBy(state, value) {
  //   state.transInfo.updBy = value
  // },
  // updateUpdOn(state, value) {
  //   state.transInfo.updOn = value
  // },
  //
  updateAccountantTransList(state, list) {
    if (list.length) {
      state.transList = list
      // state.transList = []
    } else {
      state.transList = []
    }
  },
  // updateProjSettleTransListItem(state, {row, index}) {
  //   if (state.transList && state.transList.length && index >= 0 && index < state.transList.length) {
  //     if (row) {
  //       Object.keys(row).forEach(key => {
  //         state.transList[index][key] = row[key]
  //       })
  //     } else {
  //       state.transList.splice(index, 1)
  //     }
  //   }
  // },
  updateAccountantTransListEmpty(state) {
    state.editIndex = -1
    state.justUpdatedIndex = -1
    state.transList = []
  },
  // updateProjSettleTransEmpty(state) {
  //   state.transInfo.transId = ''
  //   state.transInfo.colType = ''
  //   state.transInfo.compId = ''
  //   state.transInfo.projId = ''
  //   state.transInfo.entityId = ''
  //   // state.transInfo.ctrAcctId = ''
  //   state.transInfo.transDt = ''
  //   state.transInfo.transSummary = ''
  //   state.transInfo.contractAmt = Utils.covertZeroToNull(0)
  //   state.transInfo.feeId = ''
  //   state.transInfo.reimbOutputSettlAmt = Utils.covertZeroToNull(0)
  //   state.transInfo.reimbOfficialSettlAmt = Utils.covertZeroToNull(0)
  //   state.transInfo.payPlanAmt = Utils.covertZeroToNull(0)
  //   state.transInfo.payDebtAmt = Utils.covertZeroToNull(0)
  //   state.transInfo.payAmt = Utils.covertZeroToNull(0)
  //   state.transInfo.paymentId = ''
  //   state.transInfo.invAmt = Utils.covertZeroToNull(0)
  //   state.transInfo.docMth = ''
  //   state.transInfo.docIndex = 0
  //   state.transInfo.allowDuplicate = false
  //   state.transInfo.transRemarks = ''
  //   state.transInfo.lockBy = ''
  //   state.transInfo.lockOn = new Date(0)
  //   state.transInfo.crtBy = ''
  //   state.transInfo.crtOn = new Date(0)
  //   state.transInfo.updBy = ''
  //   state.transInfo.updOn = new Date(0)
  //
  //   state.transInfo.indUsed = ''
  // },
  // updateProjSettleTransInfo(state, transInfo) {
  //   // debugger
  //   // console.info('transInfo', transInfo)
  //   state.transInfo.transId = transInfo.transId
  //   state.transInfo.colType = transInfo.colType
  //   state.transInfo.compId = transInfo.compId
  //   state.transInfo.projId = transInfo.projId
  //   state.transInfo.entityId = transInfo.entityId
  //   // state.transInfo.ctrAcctId = transInfo.ctrAcctId
  //   state.transInfo.transDt = Utils.parseDate(transInfo.transDt)
  //   state.transInfo.transSummary = transInfo.transSummary
  //   state.transInfo.contractAmt = Utils.covertZeroToNull(transInfo.contractAmt)
  //   state.transInfo.feeId = transInfo.feeId
  //   state.transInfo.reimbOutputSettlAmt = Utils.covertZeroToNull(transInfo.reimbOutputSettlAmt)
  //   state.transInfo.reimbOfficialSettlAmt = Utils.covertZeroToNull(transInfo.reimbOfficialSettlAmt)
  //   state.transInfo.payPlanAmt = Utils.covertZeroToNull(transInfo.payPlanAmt)
  //   state.transInfo.payDebtAmt = Utils.covertZeroToNull(transInfo.payDebtAmt)
  //   state.transInfo.payAmt = Utils.covertZeroToNull(transInfo.payAmt)
  //   state.transInfo.paymentId = transInfo.paymentId
  //   state.transInfo.invAmt = Utils.covertZeroToNull(transInfo.invAmt)
  //   state.transInfo.docMth = transInfo.docMth
  //   state.transInfo.docIndex = transInfo.docIndex
  //   state.transInfo.allowDuplicate = false
  //   state.transInfo.transRemarks = transInfo.transRemarks
  //   //
  //   state.transInfo.indUsed = transInfo.indUsed
  //   // console.info('state.transInfo', state.transInfo)
  // },
  // updateEditIndex(state, value) {
  //   state.editIndex = value
  // },
  // updateJustUpdatedIndex(state, value) {
  //   state.justUpdatedIndex = value
  // },
  // updateEditAction(state, value) {
  //   state.editAction = value
  // },
  // updateEditDocMth(state, value) {
  //   state.editDocMth = value
  // },
  // updateEditDocIndex(state, value) {
  //   state.editDocIndex = value
  // },
  // updateEditAllowDuplicate(state, value) {
  //   state.editAllowDuplicate = value
  // },
  // newEmptyRowObj() {
  //   return {
  //     ctrAcctId: '',
  //     type: '',
  //     indUsed: '',
  //     status: ''
  //   }
  // },
  // appendBottomRow() {
  //   this.commit('projSettleTransManage/updateProjSettleTransEmpty')
  //   let obj = {...state.transInfo}
  //   // debugger
  //   obj.isBottomRow = true
  //   state.transList.push(obj)
  // },
  // handleAdd(state, {row, index}) {
  //   // debugger
  //   this.commit('projSettleTransManage/updateProjSettleTransEmpty')
  //   this.commit('projSettleTransManage/updateEditIndex', index)
  //   this.commit('projSettleTransManage/updateJustUpdatedIndex', -1)
  //   this.commit('projSettleTransManage/updateEditAction', 'insert')
  //   //
  //   // this.commit('projSettleTransManage/updateCtrAcctId', ctrAcctId)
  //   // this.commit('projSettleTransManage/updateCostColId', costColId)
  // },
  // handleEdit(state, {row, index}) {
  //   // debugger
  //   this.commit('projSettleTransManage/updateProjSettleTransInfo', row)
  //   this.commit('projSettleTransManage/updateEditIndex', index)
  //   this.commit('projSettleTransManage/updateJustUpdatedIndex', -1)
  //   this.commit('projSettleTransManage/updateEditAction', 'update')
  // },
  // handleEditDocIndex(state, {row, index}) {
  //   // debugger
  //   // state.editDocMth = Utils.parseDate(row.docMth)
  //   // state.editDocIndex = row.docIndex
  //   // state.editAllowDuplicate = false
  //   // 不能将当前行设置到transInfo上，添加行记录时，如果去修改索引，就会导致问题
  //   // this.commit('projSettleTransManage/updateProjSettleTransInfo', row)
  //   // this.commit('projSettleTransManage/updateEditIndex', index)
  //   // this.commit('projSettleTransManage/updateEditAction', 'update')
  // },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/project/accountantTransManage.js